import React, { useState } from "react";
import { Button, Form, Icon, Message } from "semantic-ui-react";
import { useFormik } from "formik";
import { User } from "../../../../api";
import { inititalValues, validationSchema } from "./ResetPasswordForm.form";
import "./ResetPasswordForm.scss";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../contexts";

const userController = new User();

export function ResetPasswordForm({ userByToken }) {
  const [error, setError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: userByToken.email || "",
      password: "",
      repeatPassword: "",
      resetPasswordToken: userByToken.resetPasswordToken || "",
    },
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await userController.updatePasswordByTokenApi(
          {
            email: formValue.email,
            password: formValue.password,
            repeatPassword: formValue.repeatPassword,
          },
          userByToken.resetPasswordToken
        );
        if (response && response.code === 200) {
          navigate("/admin/login");
        } else {
          setError(response.message || t("error_updating_password"));
        }
      } catch (err) {
        setError(err.msg || t("error_updating_password"));
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} className="login-form">
      <Form.Field error={!!formik.errors.email}>
        <label>{t("email")}</label>
        <div className="password-input-wrapper">
          <i className="user icon password-input-wrapper__lock" />
          <input
            name="email"
            type="email"
            placeholder={t("email")}
            value={formik.values.email}
            onChange={formik.handleChange}
          />
        </div>
        {formik.errors.email && (
          <div className="ui pointing above prompt label">{formik.errors.email}</div>
        )}
      </Form.Field>

      <Form.Field error={!!formik.errors.password}>
        <label>{t("password")}</label>
        <div className="password-input-wrapper">
          <i className="lock icon password-input-wrapper__lock" />
          <input
            type={passwordVisible ? "text" : "password"}
            name="password"
            placeholder={t("password")}
            value={formik.values.password}
            onChange={formik.handleChange}
          />
          <button
            type="button"
            className="password-input-wrapper__eye"
            onClick={() => setPasswordVisible((v) => !v)}
          >
            <Icon name={passwordVisible ? "eye slash" : "eye"} />
          </button>
        </div>
        {formik.errors.password && (
          <div className="ui pointing above prompt label">{formik.errors.password}</div>
        )}
      </Form.Field>

      <Form.Field error={!!formik.errors.repeatPassword}>
        <label>{t("repeat_password")}</label>
        <div className="password-input-wrapper">
          <i className="lock icon password-input-wrapper__lock" />
          <input
            type={repeatPasswordVisible ? "text" : "password"}
            name="repeatPassword"
            placeholder={t("repeat_password")}
            value={formik.values.repeatPassword}
            onChange={formik.handleChange}
          />
          <button
            type="button"
            className="password-input-wrapper__eye"
            onClick={() => setRepeatPasswordVisible((v) => !v)}
          >
            <Icon name={repeatPasswordVisible ? "eye slash" : "eye"} />
          </button>
        </div>
        {formik.errors.repeatPassword && (
          <div className="ui pointing above prompt label">{formik.errors.repeatPassword}</div>
        )}
      </Form.Field>

      <input type="hidden" name="resetPasswordToken" value={formik.values.resetPasswordToken} />

      {error && <Message negative content={error} style={{ marginBottom: "0.75rem" }} />}

      <Button type="submit" primary fluid size="large" loading={formik.isSubmitting}>
        {t("update")}
      </Button>
    </Form>
  );
}
